<template>
  <Loading />
</template>

<script setup lang="ts">
import { useRouter, useRoute } from "vue-router";
import { useUserStore } from "../../store/userStore";
const router = useRouter();
const userStore = useUserStore();
const route = useRoute();

onBeforeMount(() => {
  console.log("Staff SSO onBeforeMount");
});

onMounted(() => {
  //Remove token from URL
  console.log("Staff SSO");
  let urlToken = route.query.authtoken.toString();
  if (urlToken) {
    userStore.setAuthToken(urlToken);
    router.replace("/staff");
  }
});
</script>
